export default __webpack_public_path__ + "static/media/FlorenciaSepulveda.4bc18dc5.png";